import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { Nav } from '@/components/landing/Nav'
import { Hero } from '@/components/landing/Hero'
import { HowItWorks } from '@/components/landing/HowItWorks'
import { Features } from '@/components/landing/Features'
import { LocalModels } from '@/components/landing/LocalModels'
import { MagicLamp } from '@/components/landing/MagicLamp'
import { Download } from '@/components/landing/Download'
import { Faq } from '@/components/landing/Faq'
import { FinalCta } from '@/components/landing/FinalCta'
import { Footer } from '@/components/landing/Footer'

export const Route = createFileRoute('/')({
  validateSearch: z.object({
    ref: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    if (search.ref) {
      throw redirect({ to: '/waitlist', search: { ref: search.ref } })
    }
  },
  component: HomePage,
})

function HomePage() {
  return (
    <div id="top" className="min-h-screen overflow-x-clip bg-canvas font-sans text-ink">
      <Nav />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <LocalModels />
        <MagicLamp />
        <Download />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  )
}
